import { useMap, useMapsLibrary } from '@vis.gl/react-google-maps';
import { useEffect, useMemo } from 'react';

import { cn } from '@/app/utils/cn';

const dotClassName = [
  'size-5',
  'xl:size-8',
  'rounded-full',
  'border-2',
  'border-white',
  'bg-blue-400',
  'shadow-sm',
];

const createDotMarker = () => {
  const markerElement = document.createElement('div');
  markerElement.classList.add(...dotClassName);

  return markerElement;
};

interface DotMarkerProps {
  position: google.maps.LatLngLiteral;
}

export const DotMarker = ({ position }: DotMarkerProps) => {
  const markerLib = useMapsLibrary('marker');
  const map = useMap();

  const dotMarker = useMemo(() => {
    if (!map || !markerLib) return null;

    const marker = new markerLib.AdvancedMarkerElement({
      position: {
        lat: +position.lat || 0,
        lng: +position.lng || 0,
      },
      content: createDotMarker(),
    });

    return { marker } as any;
  }, [map, markerLib, position.lat, position.lng]);

  useEffect(() => {
    if (dotMarker?.marker) {
      dotMarker.marker?.setMap(map);
    }

    return () => {
      if (dotMarker?.marker) {
        dotMarker.marker.setMap(null);
      }
    };
  }, [dotMarker, map]);

  return <div className={cn(...dotClassName, 'hidden')} />;
};
